export default "__VITE_ASSET__DYDm6y4k__"